export default __webpack_public_path__ + "static/media/footer-bg.75276846.png";